import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import ArchiveTemplate from '@components/Archive/Archive';
import ContactFormTemplate from '@components/ContactForm/ContactForm';
import Exhibitors from '@components/Exhibitors/Exhibitors';
import FaqsTemplate from '@components/Faqs/Faqs';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import PackagesTemplate from '@components/SubscriptionPackages/Packages';
import VideoTemplate from '@components/SubscriptionVideo/Video';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';
import HeroTemplate from '@ui/Hero/Hero';
import { publicAssets } from '@utils/url.utils';
import { IS_PROD } from '../constants';
import { IRecordItem } from '../interfaces/Calendar';
import { calendarApi } from '../services/calendar.service';

interface IClassroomRent {
    videos: IRecordItem[];
    videosCount: number;
}

const ClassroomRent: NextPage<IClassroomRent> = ({ videos, videosCount }) => {
    const { t } = useTranslation();

    return (
        <>
            <NextSeo
                title={t('seo.subscription.title')}
                description={t('seo.subscription.description')}
                noindex={!IS_PROD}
                nofollow={!IS_PROD}
                openGraph={{
                    images: [{ url: `https://profivzdelavanie.sk${publicAssets('/og-konferencia.png')}` }],
                }}
            />
            <HeaderTemplate />
            <HeroTemplate
                titleKey="subscription.hero.title"
                imageKey="subscription_hero.webp"
                listKeys={[
                    'subscription.hero.paragraph1',
                    'subscription.hero.paragraph2',
                    'subscription.hero.paragraph3',
                    'subscription.hero.paragraph4',
                ]}
            />
            <PackagesTemplate />
            {videosCount > 0 && (
                <ContentTemplate mobileSidePadding={20}>
                    <ArchiveTemplate videos={videos} count={videosCount} />
                </ContentTemplate>
            )}
            <Exhibitors />
            <FaqsTemplate />
            <VideoTemplate />
            <ContactFormTemplate />
            <FooterTemplate />
        </>
    );
};

export async function getServerSideProps() {
    try {
        const { data: videos } = await calendarApi.getArchiveVideos();

        return {
            props: {
                videos: videos?.results,
                videosCount: videos?.total_count,
            },
        };
    } catch {
        return {
            props: {
                videos: [],
                videosCount: 0,
            },
        };
    }
}

export default ClassroomRent;
